<template>
    <div :class="['grph_area', 'swiper-container', 'chart-swiper-' + areaSeq, areaSeq === 2 ? 'mt-10' : '']">
        <div class="swiper-wrapper">
            <div v-for="(chartId, index) in chartIds" class="swiper-slide">
                <Chart :key="chartId" :chartid="chartId" v-if="index === slideIdx" />
            </div>
        </div>
        <div class="btn_pre swiper-button-prev"></div>
        <div class="btn_nxt swiper-button-next"></div>
    </div>
</template>

<script>
import Swiper from '@/assets/js/swiperjs/swiper-bundle.js';
import { $_TYPE } from '@/confs/common.const';
import Chart from '@/libs/grip.chart.v2.vue';

export default {
    props: {
        areaSeq: {
            type: Number,
            required: true,
        },
        chartInfos: {
            type: Array,
            required: true,
        },
    },
    components: {
        Chart,
    },
    data() {
        return {
            swiper: undefined,
            slideIdx: 0,
            chartTitle: '',
        }
    },
    computed: {
        chartIds(){
            return this.chartInfos;
        },
    },
    mounted() {
        if(typeof this.swiper === $_TYPE.UNDEF) {
            this.setSwiper();
        }
    },
    methods: {
        bindChartConfig(config){
            this.chartTitle = '';
            this.chartTitle = config.options.title.text;
        },
        setSwiper(){
            const _this = this;
            if(typeof this.swiper !== $_TYPE.UNDEF) {
                this.swiper.slideTo(0);
            }
            this.swiper = new Swiper('.chart-swiper-' + this.areaSeq, {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView : 1,
                // effect : 'coverflow',
                // pagination: {
                //     el: '.swiper-pagination'
                // },
                mousewheel: true,
                keyboard: true,
                // autoplay: {
                //     delay: 15000,
                //     disableOnInteraction: false,
                // },
                on: {
                    init() {
                    },
                    slideChange(e){
                        _this.slideIdx = this.realIndex;
                        _this.$eventBus.$emit("Swiper::slide-change");
                    },
                    touchMove(){
                        _this.$eventBus.$emit("Swiper::touch-move");
                    },
                },
            });
        },
    },
};
</script>
<style>
.grp_wrap .grp_title {display: block; position: absolute; font-size: 12px; top: -6px;}
@media (min-width: 2737px) and (max-width: 7680px) {
    .grp_wrap .grp_title {font-size: 36px; top: 2px;}
}
</style>
